import type { OrderEnum, PaginationInterface } from 'shared/types/swr-pagination-interface'

interface PaginationQuery {
  order?: OrderEnum.prev | undefined
  startFromId?: string | undefined
  limit?: string | undefined
}

export function getPaginationQuery({
  limit,
  pagination: { startFromId, order },
  initLimit,
}: {
  limit: number
  pagination: PaginationInterface
  initLimit: number
}): PaginationQuery {
  return {
    ...(limit !== initLimit && { limit: String(limit) }),
    ...(startFromId && { startFromId: String(startFromId) }),
    ...(order === 'prev' && { order }),
  }
}
